import { ThemeColors } from '~/themes/colors'

export interface sharedSettingsStyleColors {
  backgroundColorAlert: ThemeColors
  backgroundColorDefault: ThemeColors
  borderColorAlert: ThemeColors
  borderColorDefault: ThemeColors
  subheadingSectionBackgroundColor: ThemeColors
  helpListItemColor: ThemeColors
  helpLinkColor: ThemeColors
  helpLinkHoverColor: ThemeColors
  subLabelColor: ThemeColors
  settingItemAlertColor: ThemeColors
  menuItemWrapperBackgroundColor: ThemeColors
}

export const sharedSettingsStyleColors: sharedSettingsStyleColors = {
  backgroundColorAlert: {
    default: 'red.100',
  },
  backgroundColorDefault: {
    default: 'gray.200',
  },
  borderColorAlert: {
    default: 'red.600',
  },
  borderColorDefault: {
    default: 'gray.400',
  },
  subheadingSectionBackgroundColor: {
    default: 'gray.200',
  },
  helpListItemColor: {
    default: 'gray.800',
  },
  helpLinkColor: {
    default: 'blue.900',
  },
  helpLinkHoverColor: {
    default: 'blue.700',
  },
  subLabelColor: {
    default: 'gray.800',
  },
  settingItemAlertColor: {
    default: 'red.200',
  },
  menuItemWrapperBackgroundColor: {
    default: 'gray.100',
  },
}
